/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// actions
import { setEditMode, updatePageDetails, changePage } from '@insticator/insticator-ui';
import { editReport } from 'state/actions/reportsState/reports_status';
import { setReportProperties } from 'state/actions/reportsState/selected_report_status';
// component
import DetailPage from 'pages/dashboard/reports/detail/detail';



/* ========== ~~~~~~~~~~ REPORT DETAIL : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ appStatus, reportsState, sessionStatus }) => ({
    userFirstName: sessionStatus.userFirstName,
    isDataReceived: reportsState.reportsStatus.isDataReceived,
    selectedReportStatus: reportsState.selectedReportStatus,
    selectedReportData: reportsState.selectedReportStatus.selectedReportData,
    isReportSaved: reportsState.selectedReportStatus.status.isReportSaved,
    processing: reportsState.selectedReportStatus.status.processing,
    currentPage: appStatus.currentPage,
    reportChangeDetected: reportsState.selectedReportStatus.status.reportChangeDetected
});

// map actions
const mapDispatchToProps = dispatch => ({
	moveToPage: (location) => {
		dispatch(updatePageDetails(location));
    	dispatch(changePage(location))
    },
    editReport: reportUUID => dispatch(editReport(reportUUID)),
    setEditMode: editState => dispatch(setEditMode(editState)),
    setReportProperties: data => dispatch(setReportProperties(data))
});



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
	mapStateToProps,
    mapDispatchToProps
)(DetailPage);
